var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"keep-spaces",class:_vm.inClass},[_vm._v(" "+_vm._s(_vm.nameDisplay)+" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.name.length>_vm.widthAvailable)?_c('v-icon',_vm._g(_vm._b({attrs:{"color":"grey","dark":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-dots-horizontal ")]):_vm._e()]}}])},[_c('span',[_vm._v(_vm._s(_vm.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }